function initColorOptions() {
  const colorOptionContainers = document.querySelectorAll('.color-options-container');
  
  colorOptionContainers.forEach(container => {
    const moreButton = container.querySelector('.color-options-more');
    const customOptions = container.querySelectorAll('.option-item:not(:has(input[name="Color"][value*="(In Stock)"])');
    if (customOptions.length > 6) {
      // Hide options beyond the first 6
      customOptions.forEach((option, index) => {
        if (index >= 6) {
          option.classList.add('hidden');
        }
      });
      
      // Show the more button
      if (moreButton) {
        moreButton.classList.remove('hidden');
        moreButton.textContent = `+${customOptions.length - 6} More`;
        
        moreButton.addEventListener('click', () => {
          customOptions.forEach(option => option.classList.remove('hidden'));
          moreButton.classList.add('hidden');
        });
      }
    } else {
      // Hide the more button if there are 6 or fewer options
      if (moreButton) {
        moreButton.classList.add('hidden');
      }
    }
    container.classList.add('show');
  });
}

// Initialize when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initColorOptions);
} else {
  initColorOptions();
} 